// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"PageToolbar-toolbar-1Lo1N"};